import React from 'react';
import {
	List,
	Datagrid,
	TextField,
	Filter,
	TextInput,
	EditButton,
	SelectInput,
	FunctionField,
	Button,
} from 'react-admin';
import {
	subscriptionStatusChoices,
	take,
	valideEmail,
} from '../../Services/users';
import ConfirmDeleteButton from '../../Components/Button/ConfirmDeleteBtn';
import HanshakeIcon from '@mui/icons-material/Handshake';
import CheckIcon from '@mui/icons-material/CheckCircle';

const getStatusName = (statusId: number) => {
	const status = subscriptionStatusChoices.find(
		(choice) => choice.id === statusId
	);
	return status ? status.name : '';
};

const getRowStyle = (record: any) => {
	if (record.subscriptionStatus === 100) {
		return { backgroundColor: '#f8d7da' };
	} else if (record.subscriptionStatus === 0) {
		return { backgroundColor: '#fff3cd' };
	}
	return {}; // Pas de style pour les autres statuts
};

// Orphelin = rattaché à aucun compte de facturation et à aucun projet. Il peut
// se connecter, mais l'application n'a rien à lui montrer.
//
// ⚠️ Ce n'est pas une liste à purger : c'est ce que devient tout membre d'un
// compte supprimé, la cascade ne touchant jamais les comptes utilisateurs.
const orphanChoices = [{ id: 'true', name: 'Orphelins (sans compte ni projet)' }];

const UserFilter = (props: any) => (
	<Filter {...props}>
		<TextInput label="Search" source="q" alwaysOn />
		{/* Ajout du filtre pour subscriptionStatus */}
		<SelectInput
			label="Subscription Status"
			source="subscriptionStatus"
			choices={subscriptionStatusChoices}
		/>
		<SelectInput
			label="Rattachement"
			source="orphan"
			choices={orphanChoices}
			alwaysOn
			emptyText="Tous"
		/>
	</Filter>
);
export const UserList = (props: any) => (
	<List {...props} filters={<UserFilter />}>
		<Datagrid
			rowClick={(id, basePath, record) => `${record.id}`}
			rowSx={(record) => getRowStyle(record)}
		>
			<TextField source="id" />
			<FunctionField
				label="Subscription Status"
				render={(record) => getStatusName(record.subscriptionStatus)}
			/>
			<TextField source="name" />
			<TextField source="email" />
			<TextField source="roles" />
			<FunctionField render={(record) => <ValideUser record={record} />} />
			<FunctionField render={(record) => <TakeUser record={record} />} />
			<EditButton label="Edit" />
			<FunctionField
				render={(record) => (
					<ConfirmDeleteButton
						record={record}
						title="Delete billing account"
						entity="users"
						description="Are you sure to delete this user ?"
						confirmMessage="User is deleted"
					/>
				)}
			/>
		</Datagrid>
	</List>
);

const TakeUser = ({ record }: { record: any }) => {
	const [isPending, setIsPending] = React.useState(false);

	const handleClick = async (e: React.MouseEvent) => {
		e.stopPropagation();
		setIsPending(true);
		try {
			const res = await take(record.fb_uuid);

			const w: any = window;
			const endPoint = `${w.FRONT_URL}`;

			// Jeton dans le fragment : jamais envoyé au serveur, donc jamais dans les journaux.
			window.open(`${endPoint}/signin#token=${encodeURIComponent(res.token)}`, '_blank');
		} catch (e) {
			alert('An error occured');
		} finally {
			setIsPending(false);
		}
	};

	return (
		<>
			{record.fb_uuid && (
				<Button
					label="Take"
					color="primary"
					onClick={handleClick}
					disabled={isPending}
				>
					<HanshakeIcon />
				</Button>
			)}
			{!record.fb_uuid && <span>Never conneted</span>}
		</>
	);
};

export default TakeUser;

const ValideUser = ({ record }: { record: any }) => {
	const [isPending, setIsPending] = React.useState(false);

	const handleClick = async (e: React.MouseEvent) => {
		if (window.confirm('Are you sure to valide this user email ?')) {
			e.stopPropagation();
			setIsPending(true);
			try {
				const res = await valideEmail(record.fb_uuid);
				if (res.verified) {
					alert('Email is validated');
				}
			} catch (e) {
				alert('An error occured');
			} finally {
				setIsPending(false);
			}
		}
	};

	return (
		<>
			{record.fb_uuid && (
				<Button
					label="Valid"
					color="primary"
					onClick={handleClick}
					disabled={isPending}
				>
					<CheckIcon />
				</Button>
			)}
			{!record.fb_uuid && <span>Never conneted</span>}
		</>
	);
};
